<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="構成品マスタ"
          icon="fa-share-alt-square"
          class="masterComponent-header" />
      <span class="action_button">
        <div class="edit-button-wrap">
          <el-dropdown
              v-show="showActionButtonComponent"
              @command="actionCommand">
            <el-button size="small">
              アクション
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu
                slot="dropdown"
                class="header-action-menu">
              <el-dropdown-item
                  :disabled="$isFunctionDisabled(define.PermissionKeys.Master.Component.EDIT)"
                  :command="define.PRODUCT_COMPONENT_MODE.EDIT">
                編集
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <BaseButton v-show="isEdit"
              @click="cancel()">
            キャンセル
          </BaseButton>
          <BaseButton v-show="isEdit"
              :disabled="disableSaveButton"
              @click="save()">
            保存
          </BaseButton>
        </div>
      </span>
    </el-row>
    <BaseSearchConditionModal
        :no-condition="false"
        :keyword="searchKeyword"
        :is-and-search="isAndSearch"
        :conditions="searchConditions"
        :base-query="baseQuery"
        :store-path="storePath"
        :res-path="responsePath"
        :save-key="saveKey"
        :no-search="noSearch"
        @search="onSearch"
        @searched="onSearched" />
    <div class="base-table-list tab-list div-flex row-clickable-table">
      <div class="width-50">
        <el-row class="add-row">
          <BaseButton v-show="isEdit"
              @click="addRow('setItem')">
            行追加
          </BaseButton>
        </el-row>
        <div class="el-table el-table--enable-row-hover">
          <div class="el-table__body-wrapper">
            <table class="table">
              <tbody>
                <tr>
                  <th class="width-30">セット品目コード</th>
                  <th class="width-70">セット品目構成区分</th>
                </tr>
                <template v-for="(val, index) in componentList">
                  <template v-if="inPage(val)">
                    <tr :key="index"
                        :data-id="`${index}`"
                        class="el-table__row"
                        :class="{'tr-color': selectIndex === index}"
                        @click="onClick(index)">
                      <td>
                        <BaseCell
                            :properties="createTextAreaProp('setItemCode')"
                            :display-item="val.node"
                            :editable="val.node.isAdd === 1" />
                      </td>
                      <td>
                        <div class="div-flex">
                          <BaseCell
                              :properties="createTextAreaProp('setItemComponentType')"
                              :display-item="val.node"
                              class="width-50"
                              :editable="mode === define.PRODUCT_COMPONENT_MODE.EDIT" />
                          <BaseOperationTooltip
                              v-if="isEdit"
                              :list="getTooltipList(index, 'setItem')"
                              placement="bottom-end" />
                        </div>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
              <tr v-if="componentList.length < 1">
                <td colspan="3"
                    class="td-empty">
                  データなし
                </td>
              </tr>
            </table>
          </div>
        </div>
        <BasePagination
            v-if="showPagination"
            :current-page="currentPage"
            :size="pageSize"
            :total="totalSize"
            :total-count="0"
            @size-change="totalCount"
            @current-change="onPaginationCurrentChange" />
      </div>
      <div class="width-49">
        <el-row class="add-row">
          <BaseButton v-show="isEdit && selectIndex >= 0"
              @click="addRow('componentItem')">
            行追加
          </BaseButton>
        </el-row>
        <div class="el-table">
          <div class="el-table__body-wrapper">
            <table class="table">
              <tbody>
                <tr>
                  <th class="width-20">構成品目コード</th>
                  <th class="width-20">構成品目区分</th>
                  <th class="width-40">本体区分</th>
                  <th class="width-20">数量</th>
                </tr>
                <template v-if="componentList[selectIndex]">
                  <template v-if="componentList[selectIndex].node.isActive !== 0">
                    <template v-for="(val, index) in componentList[selectIndex].node.itemList">
                      <tr v-if="val.isActive !== 0"
                          :key="index"
                          :data-id="`${index}`">
                        <td>
                          <BaseCell
                              :properties="createTextAreaProp('componentItemCode')"
                              :display-item="val"
                              :editable="val.isAdd === 1" />
                        </td>
                        <td>
                          <BaseCell
                              :ref="`name_${index}`"
                              :properties="createTextAreaProp('componentItemType')"
                              :display-item="componentList[selectIndex].node"
                              class="width-70"
                              :editable="false" />
                        </td>
                        <td>
                          <BaseCell
                              :ref="`isBody_${index}`"
                              :properties="createTextAreaProp('isBody')"
                              :display-item="val"
                              :editable="mode === define.PRODUCT_COMPONENT_MODE.EDIT" />
                        </td>
                        <td>
                          <div class="div-flex">
                            <BaseCell
                                :properties="createTextAreaProp('componentItemNumber')"
                                :display-item="val"
                                class="width-50"
                                :editable="mode === define.PRODUCT_COMPONENT_MODE.EDIT" />
                            <BaseOperationTooltip
                                v-if="isEdit"
                                :list="getTooltipList(index, 'componentItem')"
                                placement="bottom-end" />
                          </div>
                        </td>
                      </tr>
                    </template>
                  </template>
                </template>
              </tbody>
              <tr v-if="!componentList[selectIndex] || componentList[selectIndex].node.itemList.filter(element => element.isActive !== 0).length < 1">
                <td colspan="3"
                    class="td-empty">
                  データなし
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .add-row {
    text-align: right;
    height: 35px;
  }
  .tab-list {
    padding-top: 0px !important;
  }
  .table {
    width: 100%;
  }
  .th-bottom {
    border-bottom: 1px solid #ebeef5;
  }
  .td-empty {
    text-align: center !important;
    color: #909399 !important;
  }
  .div-flex {
    display: flex;
    justify-content: space-between;
  }
  .cell-msg {
    color: #e22908;
    text-align: right;
    margin-right: 10px;
  }
  .width-20 {
    width: 20%;
  }
  .width-30 {
    width: 30%;
  }
  .width-40 {
    width: 40%;
  }
  .width-50 {
    width: 50%;
  }
  .width-49 {
    width: 49%;
  }
  .width-70 {
    width: 70%;
  }
  .tr-color {
    background-color: #fcfbed !important;
  }
</style>
<script>
import _ from 'lodash'
import { mapState, mapGetters, mapActions } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/nintendo/masterComponent'
import common from '@/utils/common'
import compare from '@/utils/compareUtils'
import * as config from '@/config'
import message from '@/utils/message'

import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import BaseSearchConditionModal from '@/components/organisms/BaseSearchConditionModal'
import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import detailUtil from '@/components/mixins/detailUtil'
import BasePagination from '@/components/molecules/BasePagination'

const componentValidationRules = (v) => {
  // セット品目コードの重複チェック
  v.$validator.extend('setItemCodeDuplicateCheck', {
    getMessage: () => '同じセット品目コードが存在します',
    validate: (data) => {
      // 該当セット品目コードはリストに既存の場合、エラーになる
      if (v.componentList.filter((val, key) => { return val.node.setItemCode === data }).length > 1) {
        return false
      }
      return true
    }
  })
  // 構成品目コードの重複チェック
  v.$validator.extend('componentItemCodeDuplicateCheck', {
    getMessage: () => '同じ構成品目コードが存在します',
    validate: (data) => {
      // 該当構成品目コードはリストに既存の場合、エラーになる
      if (v.componentList[v.selectIndex].node.itemList.filter((val, key) => { return val.componentItemCode === data }).length > 1) {
        return false
      }
      return true
    }
  })
}

export default {
  name: 'MastercomponentList',
  components: {
    BaseHeader,
    BaseCell,
    BaseButton,
    BaseSearchConditionModal,
    BaseOperationTooltip,
    BasePagination
  },
  mixins: [ x, confirmDiscardOnLeave, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      isChanged: false,
      selectIndex: 0,
      componentList: [],
      originComponentList: [],
      updateSetItemCode: []
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      mode: (state) => state.MasterComponent.mode,
      searchKeyword: (state) => state.MasterComponent.searchKeyword,
      isAndSearch: (state) => state.MasterComponent.isAndSearch,
      searchConditions: (state) => state.MasterComponent.searchConditions,
      tdLists: (state) => state.MasterComponent.tdLists
    }),
    ...mapGetters({
      conditions: 'searchConditions'
    }),
    saveKey () {
      return 'componentCondition'
    },
    storePath () {
      return 'MasterComponent'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_N_COMPONENT_LIST
    },
    responsePath () {
      return 'data.NComponent.edges'
    },
    showActionButtonComponent () {
      return (!this.isEdit && (this.$isFunctionShown(define.PermissionKeys.Master.Component.EDIT)))
    },
    isEdit () {
      return this.mode === define.PRODUCT_COMPONENT_MODE.EDIT
    },
    noSearch () {
      return this.mode === define.PRODUCT_COMPONENT_MODE.EDIT
    },
    disableSaveButton () {
      return !this.isChanged
    },
    sortCondition () {
      return this.getSortCondition(this.name)
    },
    store () {
      return this.$store.state[this.storePath] || {}
    },
    showPagination () {
      return true
    },
    currentPage () {
      return this.store[this.currentPageKey] || 0
    },
    totalSize () {
      return this.componentList.filter(row => row.node.isActive !== 0).length
    },
    totalCount () {
      return this.store.totalCount || 0
    },
    pageSize () {
      return this.store[this.sizeKey] || 0
    },
    currentPageKey () {
      return 'currentPage'
    },
    sizeKey () {
      return 'size'
    }
  },
  watch: {
    componentList: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    mode: {
      handler: function (val, oldVal) {
        if (oldVal != null) {
          // 通常モード ==> 編集モードの場合
          if (val === define.PRODUCT_COMPONENT_MODE.EDIT) {
            // 編集モードに切り替える場合
            this.originComponentList = _.cloneDeep(this.componentList)
            if (this.totalSize < 1) {
              this.selectIndex = -1
            }
            this.$_ConfirmDiscardOnLeave_watchStart(this.componentList)
          } else {
            this.isChanged = false
            // 編集モード ==> 通常モードの場合
            this.$_ConfirmDiscardOnLeave_watchEnd()
          }
        }
      },
      deep: true
    }
  },
  async created () {
    this.updateStore('mode', define.PRODUCT_COMPONENT_MODE.NORMAL)
    // 画面初期化する時に、一覧リストを取得する
    this.getDetailData()
    // カスタムバリデーションルールを追加
    componentValidationRules(this)
  },
  mounted () {
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  methods: {
    ...mapActions('LocalStorage', [
      'setPaginationSize'
    ]),
    setStore (key, val) {
      this.$store.dispatch({
        type: 'set',
        states: { [key]: val }
      })
    },
    inPage (val) {
      if (val.node.isActive === 0) {
        return false
      }
      const index = this.componentList.filter(
        row => row.node.isActive !== 0).findIndex(
        item => (item.node.setItemCode === val.node.setItemCode && item.node.nums === val.node.nums))
      const head = this.currentPage * this.pageSize
      return (index >= head) && (index <= head + this.pageSize - 1)
    },
    /**
     * 行クリック
     */
    async onClick (index) {
      // チェック処理（選択する前に既存のデータをチェックする）
      if (!await this.$validator.validate()) {
        return
      }
      // 行選択を設定
      this.selectIndex = index
    },
    onSearch (keyword, conditions) {
      this.$emit('search', keyword, conditions)
    },
    onSearched (result) {
      // 検索後、データを再取得、通常モードに戻る
      this.$emit('searched', result)
      this.componentList = this.tdLists
      // ディフォルト行選択に０を設定
      this.selectIndex = 0
      this.updateSetItemCode = []
      // 再検索後、通常モードに切り替える
      this.updateStore('mode', define.PRODUCT_COMPONENT_MODE.NORMAL)
    },
    /**
     * 画面一覧項目を生成.
     * @param {Object} path 項目キー
     */
    createTextAreaProp (path) {
      // セット品目コード
      if (path === 'setItemCode') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'required|max:8|setItemCodeDuplicateCheck', validateAs: 'セット品目コード'
        }
      }
      // セット品目構成区分
      if (path === 'setItemComponentType') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: path,
          validateRule: 'required', validateAs: 'セット品目構成区分',
          filterable: true, selectCode: this.setItemComponentTypeList,
          codeName: (code) => (this.setItemComponentTypeList().find(element => code === element.code) || {}).name
        }
      }
      // 構成品目コード
      if (path === 'componentItemCode') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'required|max:8|componentItemCodeDuplicateCheck', validateAs: '構成品目コード'
        }
      }
      // 構成品目区分
      if (path === 'componentItemType') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'setItemComponentType',
          validateRule: 'required', validateAs: '構成品目区分',
          filterable: true, selectCode: this.componentItemTypeList,
          codeName: (code) => (this.componentItemTypeList().find(element => code === element.code) || {}).name
        }
      }
      // 本体区分
      if (path === 'isBody') {
        return {
          path: path, type: 'String', elementType: ELEMENT_TYPE.RADIO_BUTTON,
          selectCode: () => [
            { code: 0, name: '構成品' },
            { code: 1, name: '本体' }
          ]
        }
      }
      // 数量
      if (path === 'componentItemNumber') {
        return {
          type: 'Number', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'required|numeric|min_value:1|max_value:9999', validateAs: '数量'
        }
      }
    },
    /**
     * セット品目構成区分リストを取得する
     */
    setItemComponentTypeList () {
      return [ { code: 0, name: '親' }, { code: 1, name: '売上' } ]
    },
    /**
     * セット品目構成区分リストを取得する
     */
    componentItemTypeList () {
      return [ { code: 0, name: '売上' }, { code: 1, name: '在庫' } ]
    },
    /**
     * 構成品Tooltipの項目を返却する.
     * @param {Object} row 注文情報
     * @return {Array}
     */
    getTooltipList (index, type) {
      return [
        {
          title: '削除',
          click: () => this.delete(index, type)
        }
      ]
    },
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },

    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.PRODUCT_COMPONENT_MODE.EDIT:
          this.edit()
          break
        default: {}
      }
    },
    /**
     * 構成品目情報を取得する。
     */
    async getDetailData (update = false) {
      try {
        this.$loadingService.show()
        const queryCondition = this.conditions(this.storePath)
        // 構成品目検索APIを呼び出す
        const res = await this.execGraphQl(queryCondition)
        // DBから画面の情報を取得
        this.componentList = res

        if (update && this.updateSetItemCode.length > 0) {
          const addQueryCondition = { setItemCode: this.updateSetItemCode }
          // 構成品目検索APIを呼び出す
          const res = await this.execGraphQl(addQueryCondition)

          // 保存後データ抽出する場合、既存データを上書きする
          res.map(row => {
            const idx = this.componentList.findIndex(item => item.node.setItemCode === row.node.setItemCode)
            if (idx < 0) {
              this.componentList.push(row)
            }
          })
        }
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * 構成品目情報を取得する。
     */
    async execGraphQl (condition) {
      // 検索SQLを作成する
      const queryQL = common.addGraphQlCondition(query.GRAPH_QL_QUERY_N_COMPONENT_LIST, condition)
      // 構成品目検索APIを呼び出す
      const res = await common.postGraphQl(queryQL)
      // DBから画面の情報を取得
      return res.data.data.NComponent.edges
    },
    /**
     * EDIT処理
     */
    async edit () {
      // 編集モードに切り替える
      this.updateStore('mode', define.PRODUCT_COMPONENT_MODE.EDIT)
    },
    /**
     * 新規構成品行を生成.
     */
    async addRow (type) {
      if (type === 'setItem') {
        // チェック処理（新規する前に既存のデータをチェックする）
        if (!await this.$validator.validate()) {
          return
        }
        // 全体チェック処理
        // エラーあるIndex取得
        const errorIndex = await this.validate()
        // エラーある場合
        if (errorIndex >= 0) {
          // エラーあるページに遷移
          this.updateStore(this.currentPageKey, parseInt(errorIndex / this.pageSize))
          setTimeout(() => {
            this.$validator.validate()
          }, 100)
          return
        }
        // セット品目行追加の場合
        const itemList = [{ componentItemCode: '', isBody: 0, isAdd: 1, componentItemNumber: 1, isActive: 1 }]
        this.componentList.push({ node: { setItemCode: '', setItemComponentType: 0, itemList: itemList, isAdd: 1, isActive: 1, nums: Math.random() } })
        this.selectIndex = this.componentList.length - 1
        this.getcurrentPage(true)
      } else {
        // 構成品行追加の場合
        this.componentList[this.selectIndex].node.itemList.push({ componentItemCode: '', isBody: 0, isAdd: 1, componentItemNumber: 1, isActive: 1 })
      }
    },
    /**
     * 構成品目削除を行う
     * @param {Number} index インデックス
     */
    delete (index, type) {
      if (type === 'setItem') {
        // セット品目を削除する場合
        if (this.componentList[index].node.isAdd === 1) {
          // 追加行の場合、そのまま削除する
          this.componentList.splice(index, 1)
        } else {
          // 既存行の場合、削除フラグに０を更新する
          this.$set(this.componentList[index].node, 'isActive', 0)
        }
        this.getcurrentPage(false)
        if (index === this.selectIndex) {
          this.selectIndex = -1
        }
      } else {
        // 構成品目を削除する場合
        if (this.componentList[this.selectIndex].node.itemList[index].isAdd === 1) {
          // 追加行の場合、そのまま削除する
          this.componentList[this.selectIndex].node.itemList.splice(index, 1)
        } else {
          // 既存行の場合、削除フラグに０を更新する
          this.$set(this.componentList[this.selectIndex].node.itemList[index], 'isActive', 0)
        }
      }
    },
    getcurrentPage (isAdd) {
      let maxPage
      if (this.totalSize % this.pageSize === 0) {
        maxPage = (this.totalSize / this.pageSize) - 1
      } else {
        maxPage = parseInt(this.totalSize / this.pageSize)
      }
      if (isAdd || (this.currentPage > maxPage)) {
        this.updateStore(this.currentPageKey, maxPage)
      }
    },
    /**
     * セット品目リストチェック処理（ページ遷移して保存する場合、追加品目対象をチェックする）
     */
    async validate () {
      return _.findIndex(this.componentList, setItem => {
        // 追加品目対象のみ
        if (setItem.node.isAdd === 1) {
          // セット品目コード
          const setItemCode = setItem.node.setItemCode
          // 空白の場合エラー
          if (setItemCode === '') {
            return true
          }
          // 8文字以上の場合エラー
          if (setItemCode.length > 8) {
            return true
          }
          // 全体セット品目コードの重複レコードがある場合エラー
          if (this.componentList.filter((val, key) => { return val.node.setItemCode === setItemCode }).length > 1) {
            return true
          }
        }
      })
    },
    /**
     * セット品目編集保存を行う
     */
    async save () {
      // 当ページチェック処理
      if (!await this.$validator.validate()) {
        return
      }
      // 全体チェック処理
      // エラーあるIndex取得
      const errorIndex = await this.validate()
      // エラーある場合
      if (errorIndex >= 0) {
        // エラーあるページに遷移
        this.updateStore(this.currentPageKey, parseInt(errorIndex / this.pageSize))
        setTimeout(() => {
          this.$validator.validate()
        }, 100)
        return
      }

      // 保存を行う
      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // 構成品目編集パラメータの作成
          const data = this.buildRequestForUpdate()
          // 構成品目編集保存を行う
          await this.updateComponentApi(data)
          // 再検索を行う
          await this.getDetailData(true)
          // 編集保存後、通常モードに切り替える
          this.updateStore('mode', define.PRODUCT_COMPONENT_MODE.NORMAL)
          this.$notify.success('保存しました。')
        } catch (error) {
          this.updateSetItemCode = []
          const data = _.get(error, 'response.data')
          if (data == null) {
            // システムエラー
            common.addError(error, { msg: message.MSG_502() })
          } else {
            // APIエラー
            common.addError(error, { msg: message.MSG_547() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    /**
     * 構成品目編集キャンセルを行う
     */
    async cancel () {
      const cancelEdit = () => {
        // 通常モードに切り替える
        this.updateStore('mode', define.PRODUCT_COMPONENT_MODE.NORMAL)
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm('構成品目変更を破棄しますか？',
        define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }
      ).then(() => {
        // 再検索を行う
        this.getDetailData()
        cancelEdit()
      }).catch(() => {
      })
    },
    /**
     * 一覧 から構成品目更新APIのリクエストパラメータを作成する.
     * originDataとの差分のみ戻り値とする.
     */
    buildRequestForUpdate () {
      let setList = []
      // 差分レコードを取得
      const diffList = compare.diff(this.originComponentList, this.componentList)
      for (const index in diffList) {
        const diffItem = diffList[index].node
        const setItem = this.componentList[index].node
        // 追加セット品目且つ構成品目リストが０件の場合
        if (diffItem.isAdd === 1 && diffItem.itemList.length < 1) {
          continue
        }
        // 構成品目情報の生成
        const itemList = []
        // セット品目情報変更する場合、対応の構成品目リスト全体をパラメータにする
        if ('isActive' in diffItem || 'setItemComponentType' in diffItem) {
          for (const item of setItem.itemList) {
            itemList.push(
              {
                componentItemCode: item.componentItemCode, // 構成品目コード
                isBody: item.isBody, // 本体フラグ
                qty: item.componentItemNumber, // 構成品目数
                updatedAt: item.updatedAt, // 更新日時
                isActive: item.isActive // 構成品削除フラグ
              })
          }
        } else {
          // 構成品目変更したのみをパラメータにする
          for (const itemIndex in diffItem.itemList) {
            const componentItem = setItem.itemList[itemIndex]
            itemList.push(
              {
                componentItemCode: componentItem.componentItemCode, // 構成品目コード
                isBody: componentItem.isBody, // 本体フラグ
                qty: componentItem.componentItemNumber, // 構成品目数
                updatedAt: componentItem.updatedAt, // 更新日時
                isActive: componentItem.isActive == null ? 1 : componentItem.isActive // 構成品削除フラグ
              })
          }
        }
        // セット品目情報を生成
        if (diffItem.isAdd === 1) {
          // 追加の場合isActiveが要らない
          setList.push(
            {
              setItemCode: setItem.setItemCode, // セット品目コード
              setItemComponentType: setItem.setItemComponentType, // セット品目構成区分
              itemList: itemList
            })
        } else {
          // 追加以外の場合isActiveが付きます
          setList.push(
            {
              setItemCode: setItem.setItemCode, // セット品目コード
              setItemComponentType: setItem.setItemComponentType, // セット品目構成区分
              itemList: itemList,
              isActive: setItem.isActive == null ? 1 : setItem.isActive // セット品目削除フラグ
            })
        }
        // 再検索用条件取得
        if (setItem.isAdd === 1) {
          this.updateSetItemCode.push(setItem.setItemCode)
        }
      }
      return setList
    },
    /**
     * 構成品目更新APIを呼び出す
     */
    async updateComponentApi (setList) {
      const data = {
        'data': { 'setList': setList }
      }
      const url = config.N_COMPONENT_URL
      const method = 'post'
      const response = await common.apiAxios(url, { method, data })
      return response
    },
    /**
     * ストアの情報を更新する
     */
    updateStore (key, val) {
      this.setStore(`${this.storePath}/${key}`, val)
    },
    /**
     * ページ番号の情報を更新する
     */
    onPaginationCurrentChange (val) {
      this.localCurrentPage = val
      this.updateStore(this.currentPageKey, val)
      this.$emit('pagination-current-change', val)
    },
    /**
     * ページサイズの情報を更新する
     */
    onPaginationSizeChange (val) {
      this.updateStore(this.sizeKey, val)
      this.setPaginationSize({ path: this.name, size: val })

      this.$emit('pagination-size-change', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/master/nintendo/MasterComponentTop.vue